import { ethers } from 'ethers';
import { Keypair } from '@solana/web3.js';
import bs58 from 'bs58';
import { slackLogger } from '@shared/utils/off-chain/slack-logger';
import { SuiWalletGenerator } from '@shared/services/helpers/sui/wallet-generation.service';
import { fetchIPFSData } from '../misc/fetchIPFSData';
import { encrypt } from '@/hooks/auth/useGetWrappedWallet';
export async function signatureToDecryptEncryptedWallet({
  PKP,
  litSession,
  litNodeClient,
  litCachedMinSig,
  setLitCachedMinSig
}) {
  const startTime = Date.now();
  try {
    const messageToVerify_0 = 'EVM Import, SVM Wallet, Pairing Message 0';
    let signature;
    if (litCachedMinSig) {
      signature = litCachedMinSig;
    } else {
      const signResponse = await litNodeClient.pkpSign({
        pubKey: PKP.publicKey,
        sessionSigs: litSession,
        toSign: prepMessage(messageToVerify_0)
      });
      signature = signResponse === null || signResponse === void 0 ? void 0 : signResponse.signature;
      // Save signature to local storage
      setLitCachedMinSig(signature);
    }
    console.log('WUJI, time to get cache call signature', Date.now() - startTime);
    return signature;
  } catch (e) {
    console.error('WUJI Error in signatureToDecryptEncryptedWallet: ', e);
    await slackLogger({
      type: 'APPLICATION_ERROR',
      pkp: PKP,
      payload: {
        type: 'signatureToDecryptEncryptedWallet',
        error: JSON.stringify(e)
      }
    });
    return {
      error: e
    };
  }
}
export async function decryptEncryptedWallet({
  PKP,
  litSession,
  litNodeClient,
  encryptedWallet,
  signature,
  setCipher1,
  setCipher2,
  setCipher3
}) {
  var _a;
  try {
    const code = await fetchIPFSData('Qmdn3AEqUf3WfS4L5XLdAtqm8eDvkLvHRDZJYfEW9vdTzf');
    const encryptionSig = signature === null || signature === void 0 ? void 0 : signature.slice(3, 35);
    const resp = await litNodeClient.executeJs({
      code: code,
      sessionSigs: litSession,
      jsParams: {
        ipfsHash: 'Qmdn3AEqUf3WfS4L5XLdAtqm8eDvkLvHRDZJYfEW9vdTzf',
        signature,
        ethAddress: PKP === null || PKP === void 0 ? void 0 : PKP.ethAddress,
        encrypt: false,
        ciphertext: encryptedWallet.ciphertext,
        dataToEncryptHash: encryptedWallet.data_to_encrypt_hash,
        verifyIndex: 0
      }
    });
    if (!(resp === null || resp === void 0 ? void 0 : resp.response)) {
      throw new Error(`decryptEncryptedWallet Error in decrypting the wallet. No response from Lit. Response: ${JSON.stringify(resp, null, 2)}, params: ${JSON.stringify({
        ipfsHash: 'Qmdn3AEqUf3WfS4L5XLdAtqm8eDvkLvHRDZJYfEW9vdTzf',
        signature,
        ethAddress: PKP === null || PKP === void 0 ? void 0 : PKP.ethAddress,
        encrypt: false,
        ciphertext: encryptedWallet.ciphertext,
        dataToEncryptHash: encryptedWallet.data_to_encrypt_hash,
        verifyIndex: 0
      }, null, 2)}, encryptedWallet: ${JSON.stringify(encryptedWallet, null, 2)}`);
    }
    if (encryptedWallet.type === 'EVM') {
      const privateKey = resp === null || resp === void 0 ? void 0 : resp.response;
      const encryptedEVMKey = encrypt(privateKey, encryptionSig);
      setCipher1(encryptedEVMKey);
      localStorage.setItem('cipher1', JSON.stringify(encryptedEVMKey));
      // console.log('wuji set cipher1', encryptedEVMKey);
      return {
        address: encryptedWallet.address,
        privateKey: privateKey,
        wallet: new ethers.Wallet(resp === null || resp === void 0 ? void 0 : resp.response)
      };
    }
    if (encryptedWallet.type === 'Solana') {
      const respArray = (_a = resp === null || resp === void 0 ? void 0 : resp.response) === null || _a === void 0 ? void 0 : _a.split(',').map(x => parseInt(x));
      const solanaKeyPair = Keypair.fromSecretKey(new Uint8Array(respArray));
      const encryptedSolanaKey = encrypt(bs58.encode(solanaKeyPair.secretKey), encryptionSig);
      setCipher2(encryptedSolanaKey);
      localStorage.setItem('cipher2', JSON.stringify(encryptedSolanaKey));
      // console.log('wuji set cipher2', encryptedSolanaKey);
      return {
        keypair: solanaKeyPair,
        address: encryptedWallet.address,
        privateKey: bs58.encode(solanaKeyPair.secretKey)
      };
    }
    if (encryptedWallet.type === 'Sui') {
      const mnemonic = resp === null || resp === void 0 ? void 0 : resp.response;
      const encryptedMnemonic = encrypt(mnemonic, encryptionSig);
      const wallet = SuiWalletGenerator.generateWalletFromMnemonic(mnemonic);
      const privateKey = wallet.privateKey;
      const keypair = wallet.keypair;
      setCipher3(encryptedMnemonic);
      localStorage.setItem('cipher3', JSON.stringify(encryptedMnemonic));
      return {
        address: encryptedWallet.address,
        privateKey: privateKey,
        keypair
      };
    }
  } catch (e) {
    console.error('WUJI Error in decryptEncryptedWallet: ', e);
    await slackLogger({
      type: 'APPLICATION_ERROR',
      pkp: PKP,
      payload: {
        mode: 'decryptEncryptedWallet',
        error: JSON.stringify(e),
        walletType: encryptedWallet.type
      }
    });
    return {
      error: e
    };
  }
}
export const prepMessage = message => {
  return ethers.utils.arrayify(ethers.utils.keccak256(ethers.utils.toUtf8Bytes(message)));
};